import React from "react"
import MegaMenu from "../MegaMenu"

const MegaMenuSearch = ({ term }) => {
  return (
    <MegaMenu
      term={term}
      name={"search"}
    />
  )
}

export default MegaMenuSearch
